/* src/app/portal/shared/data-summary/data-summary.component.scss */
.card {
  border: 1px solid #2a71bf;
}
.card-header {
  background-color: #2a71bf;
  height: 37px;
  line-height: 0.5;
}
.card-header label {
  color: #f3f3f3;
  font-size: 14px;
  font-weight: 500;
  margin-left: -10px;
}
.card-header .actions {
  float: right;
  margin: -6px -20px 0px 0px;
}
.card-header .actions label {
  font-size: 15px;
  font-weight: 400;
}
.card-header .actions select {
  line-height: 0.5;
  height: 24px;
  width: 115px;
  background-color: #f3f3f3;
  color: black;
  font-size: 12px;
  margin: 0px 5px 0px 5px;
}
.card-header .actions .btn {
  line-height: 0.5;
  height: 24px;
  background-color: #f3f3f3;
  color: black;
  font-size: 12px;
  margin: 0px 5px 0px 5px;
}
.card-header .actions .btn i {
  font-size: 18px;
  line-height: 0.5;
  margin-top: 2px;
}
.heading {
  height: 75px;
}
.heading label {
  height: 24px;
  width: 250px;
  background-color: #d3e7ef;
  padding: 2px 5px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.5;
}
.heading .btn {
  float: right;
  height: 26px;
  width: 185px;
  font-size: 12px;
  font-weight: 500;
  background-color: #f3f3f3;
  color: black;
  border: 1px solid lightgrey;
  line-height: 0;
}
.heading .btn-secondary {
  width: auto;
  margin: 0px 7px 0px 7px;
}
.data-summary-th {
  line-height: 2px;
}
.data-summary-tr {
  line-height: 5px;
  font-family: Calibri;
  font-size: 15px;
}
.data-summary-td {
  text-align: left;
}
::-webkit-scrollbar {
  border-radius: 6px;
  width: 5px !important;
  min-width: 5px !important;
  max-width: 5px !important;
  height: 4px !important;
  min-height: 8px !important;
  max-height: 8px !important;
  border: 5px solid #bec2b4 !important;
}
::-webkit-scrollbar-track {
  background: #bec2b4 !important;
  width: 5px;
}
::-webkit-scrollbar-thumb {
  border-radius: 4px !important;
  background: #bec2b4 !important;
  height: 10px !important;
}
/*# sourceMappingURL=data-summary.component-3AGYI5OY.css.map */
